import React from "react";
import PropTypes from "prop-types";
import { isFunction, gatherClasses } from "../../lib/utils";

const CustomNode = ({ node, index }) => (
  <div
    className="oui-tree-node oui-tree-node-parent oui-tree-custom-node"
    role="treeitem"
    aria-level={node.level + 1}
    tabIndex={index === 0 ? 0 : 1}
  >
    <div
      className={gatherClasses(null, "oui-tree-text", node.className)}
      style={{ minHeight: "42px" }}
    >
      {isFunction(node.renderComponent) ? node.renderComponent() : null}
    </div>
  </div>
);

CustomNode.propTypes = {
  node: PropTypes.shape({
    renderComponent: PropTypes.func.isRequired,
    className: PropTypes.string,
    level: PropTypes.number
  }),
  index: PropTypes.number
};

CustomNode.displayName = "OrionTreeCustomNode";

export default CustomNode;
